<template>
  <!-- Static navbar -->
  <div>
    <nav class="navbar navbar-fixed-top" role="navigation">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#top-navbar-1"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#"
            >EMAP - PC 57</a
          >
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="top-navbar-1">
          <ul class="nav navbar-nav navbar-right">
            <li><router-link to="/login">Login</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
<div class="page-title top-content" v-bind:style="{ 'background-image': 'url(' + bg + ')'}" style="background-repeat:no-repeat;
-webkit-background-size:cover;
-moz-background-size:cover;
-o-background-size:cover;
background-size:cover;
background-position:center;">
      <div
        class="page-title-text wow fadeInUp animated"
        style="visibility: visible; animation-name: fadeInUp"
      >
        <h1>Seu cadastro foi confirmado com sucesso!</h1>
        <p>
          <router-link class="btn btn-lg btn-block btn-primary" to="/login" role="button" >Realizar login agora</router-link>
        </p>
      </div>
    </div>

    <!-- /container -->

    <div class="section-container">
      <!-- Main component for a primary marketing message or call to action -->
      <div class="jumbotron">
        <p class="text-center">
          EMAP. Empresa Maranhense de Administração Portuária.
        </p>
        <p class="text-center">Todos os direitos reservados 2021</p>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "../../assets/img/logo.png";
import bg from "../../assets/img/bg.jpeg";

export default {
  name: "ConfirmToken",
  data() {
    return {
      info: null,
      logo: logo,
      bg: bg
    };
  },
  methods: {
  
  },
  mounted(){

    const url = document.location
    const urlFormated = url.toString().replace('/#/', '/')
    const link = new URL(urlFormated)
    const token = link.searchParams.get('token')


    this.$http.post(`/auth/confirm-token?token=${token}`)
      .then(response => {
          console.log(`deu certo ${response.data.email}`)
      })
      .catch(error => {
        console.log(error)
        console.log('errado')
      })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background: #fff;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  color: #666;
  text-align: center;
}

strong {
  font-weight: 700;
}

a,
a:hover,
a:focus {
  color: #e89a3e;
  text-decoration: none;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
}

h1,
h2 {
  margin-top: 10px;
  font-size: 42px;
  font-weight: 700;
  color: #666;
  line-height: 54px;
}

h3 {
  font-size: 26px;
  font-weight: 700;
  color: #666;
  line-height: 30px;
}

img {
  max-width: 100%;
}

::-moz-selection {
  background: #e89a3e;
  color: #fff;
  text-shadow: none;
}
::selection {
  background: #e89a3e;
  color: #fff;
  text-shadow: none;
}

/***** Loader *****/

.loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden !important;
  z-index: 99999;
}

.loader-img {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  /* background: url(../img/loading.gif) center center no-repeat; */
}

/***** General style, all sections *****/

.section-container {
  margin: 0 auto;
  padding-bottom: 60px;
}

.section-container-gray {
  background: #f8f8f8;
}

.section-container-full-bg,
.section-container-full-bg h1,
.section-container-full-bg h2,
.section-container-full-bg h3,
.section-container-full-bg h4 {
  color: #fff;
}

.section-description {
  margin-top: 60px;
  padding-bottom: 10px;
}

.section-description p {
  padding: 0 120px;
  margin-top: 30px;
  font-size: 22px;
  line-height: 36px;
}

.section-bottom-link {
  padding-top: 15px;
  padding-bottom: 20px;
}

.big-link-1 {
  display: inline-block;
  margin: 0 5px;
  padding: 12px 20px 13px 20px;
  background: #e89a3e;
  border: 0;
  border-bottom: 5px solid #cc7a19;
  font-size: 22px;
  font-weight: 300;
  line-height: 22px;
  color: #fff;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}
.big-link-1:hover,
.big-link-1:focus,
.big-link-1:active {
  outline: 0;
  opacity: 0.6;
  color: #fff;
}

/***** Dividers *****/

.divider-1 span {
  display: inline-block;
  width: 300px;
  height: 1px;
  background: #ddd;
}

.divider-1-bottom {
  padding-top: 10px;
  padding-bottom: 5px;
}

/***** Top menu *****/

.navbar {
  margin-bottom: 0;
  background: #333;
  background: rgba(51, 51, 51, 0.8);
  border: 0;
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

ul.navbar-nav {
  font-size: 16px;
  color: #888;
}

ul.navbar-nav li a {
  padding-top: 23px;
  padding-bottom: 23px;
  color: #fff;
}
ul.navbar-nav li a:hover {
  background: none;
  color: #e89a3e;
}
ul.navbar-nav li a:focus {
  background: none;
  color: #e89a3e;
  outline: 0;
}

.navbar > .container .navbar-brand {
  margin-left: 0;
}

.navbar-brand {
  width: 125px;
  height: 66px;
  text-indent: -99999px;
  background: url(../../assets/img/logo.png) left center no-repeat;
}

/***** Page title *****/

.page-title {
  padding: 200px 0 160px 0;
}

.page-title-text {
  width: 700px;
  margin: 0 auto;
  color: #fff;
}

.page-title-text h1 {
  color: #fff;
  text-shadow: 0 1px 6px rgba(51, 51, 51, 0.2);
}

.page-title-text p {
  margin-top: 20px;
  font-size: 22px;
  line-height: 36px;
  text-shadow: 0 1px 5px rgba(51, 51, 51, 0.4);
}

.subscribe form {
  margin-top: 40px;
  margin-bottom: 20px;
}

.subscribe form input.subscribe-email {
  width: 362px;
  height: 52px;
  border-color: #fff;
}
.subscribe form.email-error input.subscribe-email {
  border-color: #e89a3e;
}

.success-message {
  display: none;
  margin: 20px 0 10px 0;
  font-size: 22px;
  line-height: 36px;
}

.scroll-down {
  padding-top: 40px;
  font-size: 36px;
  text-align: center;
}
.scroll-down a {
  color: #fff;
}
.scroll-down a:hover,
.scroll-down a:focus,
.scroll-down a:active {
  outline: 0;
  opacity: 0.6;
  color: #fff;
}

/***** Counter *****/

.counter-container {
  padding-top: 50px;
}

.counter-text {
  padding-top: 30px;
  padding-bottom: 20px;
}

.counter-text h3 {
  margin-top: 0;
  padding: 10px 0;
}

.counter-text p {
  font-size: 18px;
  line-height: 32px;
}

.counter-text .timer {
  padding-top: 15px;
  font-size: 42px;
  line-height: 54px;
}

.counter-text .timer .days,
.counter-text .timer .hours,
.counter-text .timer .minutes,
.counter-text .timer .seconds {
  font-weight: 700;
}

.counter-text .timer .slash {
  color: #ddd;
}
.counter-text .timer .t-text {
  color: #888;
}

.counter-container .container {
  position: relative;
  overflow: hidden;
}

.counter-icon-container {
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 20px;
  font-size: 270px;
  color: #eee;
  line-height: 300px;
  -ms-transform: rotate(20deg);
  -moz-transform: rotate(20deg);
  -webkit-transform: rotate(20deg);
  transform: rotate(20deg);
}

/***** The project (block 3) *****/

.block-3-box {
  margin-top: 30px;
}

.block-3-box h3 {
  padding: 10px 0;
}

.block-3-box p {
  font-size: 18px;
  line-height: 32px;
}

.block-3-box .block-3-box-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  padding-top: 19px;
  background: #e89a3e;
  border: 1px solid #e89a3e;
  -moz-border-radius: 40px;
  -webkit-border-radius: 40px;
  border-radius: 40px;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  font-size: 34px;
  color: #fff;
  line-height: 34px;
  text-align: center;
}
.block-3-box .block-3-box-icon:hover {
  background: none;
  color: #e89a3e;
}

.block-3-box .block-3-box-icon i,
.block-3-box .block-3-box-icon span {
  vertical-align: middle;
}

/***** Our motto *****/

.our-motto {
  color: #fff;
}

.our-motto p {
  margin-top: 10px;
  text-align: center;
  text-shadow: 0 1px 5px rgba(51, 51, 51, 0.4);
}

.our-motto-author {
  margin-top: 30px;
  font-size: 22px;
  line-height: 36px;
}

/***** Testimonials *****/

.testimonials p {
  padding: 0;
  font-size: 18px;
  line-height: 32px;
}

.testimonial-single {
  display: inline-block;
}

.testimonial-single p {
  display: none;
}

.testimonial-single-image {
  display: inline-block;
  width: 58px;
  margin: 0 10px 10px 0;
}

.testimonial-single-image img {
  width: 100%;
  opacity: 0.3;
  cursor: pointer;
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
}

.testimonial-active {
  padding-bottom: 20px;
}

.testimonial-active p a {
  display: inline-block;
  padding-top: 15px;
  color: #666;
  font-weight: 700;
}

.testimonials-container .container {
  position: relative;
  overflow: hidden;
}

.testimonials-icon-container {
  position: absolute;
  top: 50px;
  left: 0;
  padding-left: 20px;
  font-size: 320px;
  color: #eee;
  line-height: 300px;
  -ms-transform: rotate(20deg);
  -moz-transform: rotate(20deg);
  -webkit-transform: rotate(20deg);
  transform: rotate(20deg);
}

/***** Counters *****/

.counters-container {
  padding-top: 50px;
}

.counter-box h3 {
  text-shadow: 0 1px 6px rgba(51, 51, 51, 0.2);
}

.counter-box h4 {
  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  text-shadow: 0 1px 6px rgba(51, 51, 51, 0.2);
}

.counter-box p {
  font-size: 22px;
  line-height: 36px;
}

/***** About us *****/

.about-box {
  padding-top: 30px;
  padding-bottom: 20px;
  text-align: left;
  overflow: hidden;
}

.about-box-left {
  width: 28%;
}
.about-box-right {
  width: 70%;
}

.about-box-1 .about-box-left {
  float: right;
}
.about-box-1 .about-box-right {
  float: left;
  padding-right: 5%;
  text-align: right;
}

.about-box-2 .about-box-left {
  float: left;
}
.about-box-2 .about-box-right {
  float: right;
  padding-left: 5%;
}

.about-box-3 .about-box-left {
  float: right;
}
.about-box-3 .about-box-right {
  float: left;
  padding-right: 5%;
  text-align: right;
}

.about-box-4 .about-box-left {
  float: left;
}
.about-box-4 .about-box-right {
  float: right;
  padding-left: 5%;
}

.about-box-left img {
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.about-box h3 {
  margin-top: 0;
}

.about-box p {
  font-size: 18px;
  line-height: 32px;
}

.about-social {
  margin-top: 5px;
  font-size: 31px;
}

.about-box-1 .about-social a,
.about-box-3 .about-social a {
  margin: 0 0 0 10px;
}

.about-box-2 .about-social a,
.about-box-4 .about-social a {
  margin: 0 10px 0 0;
}

.about-social a {
  color: #ddd;
}
.about-social a:hover,
.about-social a:focus {
  color: #ddd;
  opacity: 0.6;
}

/***** Call to action *****/

.call-to-action p {
  margin-top: 10px;
  text-shadow: 0 1px 5px rgba(51, 51, 51, 0.4);
}

/***** Contact us *****/

.contact-form {
  padding-top: 30px;
  padding-bottom: 20px;
}

.contact-form p {
  margin: 0;
  font-size: 18px;
  line-height: 32px;
}

.contact-form form input,
.contact-form form textarea {
  width: 95%;
  height: 52px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5px;
  border-color: #ddd;
  color: #666;
}

.contact-form form textarea {
  height: 162px;
}

.contact-form input[type="text"]:-moz-placeholder,
.contact-form textarea.form-control:-moz-placeholder {
  color: #666;
}
.contact-form input[type="text"]:-ms-input-placeholder,
.contact-form textarea.form-control:-ms-input-placeholder {
  color: #666;
}
.contact-form input[type="text"]::-webkit-input-placeholder,
.contact-form textarea.form-control::-webkit-input-placeholder {
  color: #666;
}

.contact-form form .contact-error {
  border-color: #e89a3e;
}

.contact-form form button {
  width: 95%;
}

.scroll-to-top {
  padding-top: 30px;
  font-size: 36px;
  text-align: center;
}
.scroll-to-top a {
  color: #ddd;
}
.scroll-to-top a:hover,
.scroll-to-top a:focus,
.scroll-to-top a:active {
  outline: 0;
  opacity: 0.6;
  color: #ddd;
}

/***** Footer *****/

footer {
  padding: 25px 0 20px 0;
  background: #333;
  text-align: right;
}

.footer-copyright {
  margin: 11px 0 0 0;
  font-size: 18px;
  color: #fff;
  line-height: 32px;
  text-align: left;
}
.footer-copyright a {
  color: #fff;
  border: 0;
}
.footer-copyright a:hover,
.footer-copyright a:focus {
  color: #fff;
  border-bottom: 1px dotted #fff;
}

.footer-social a {
  margin: 0 8px;
  font-size: 39px;
  color: #555;
}
.footer-social a:hover,
.footer-social a:focus {
  color: #555;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ConfirmToken.vue